$(document).ready(function () {
    // Content section buttons
    if ($('.button-cms-red').length > 0) {
        $('.button-cms-red').each(function(){
            var content = '';
            content += "<p class='p-outer'>";
            content += $(this).text();
            content += "</p>";
            content += "<div class='button-cms-red__inner'><p class='p-inner'>";
            content += $(this).text();
            content += "</p></div>";
            $(this).empty();
            $(this).append(content);
		});
    }
});